<template>
  <div class="travelNav" :class="isHotelDetail && 'isHotelDetail'" :style="isEventBgColor && `background-color: ${headerBgColor}`">
    <div v-if="!hideNavBar" class="travelNav__wrap" :class="isSearchBar ? 'border-b border-grey-lightest' : ''">
      <router-link class="logo-wrap" :to="{name: 'Home'}">
        <img class="logo" :height="isDesktop ? 45 : 36" :width="isDesktop ? 192 : 164" :src="(isWhite || isEventWhite) ? this.getWhiteLogo() : this.getLogo()" alt="OwlJourney">
      </router-link>
      <div v-if="!hideLogout" class="travelNav--right">
        <ul>
          <li>
            <div class="nav-dropdown">
              <router-link class="nav-dropdown__display no-underline" :to="{ name: 'Socket' }">
                <button class="btn btn-sm flex items-center nav-text" :style="isEventWhite ? 'color: white' : 'color: black'">
                  {{  $t('chatbot.title') }}
                </button>
                <div class="absolute bg-red text-white rounded-full text-xs border border-white" style="padding: 2px 6px; right: -8px; top: 0px;">
                  HOT
                </div>
              </router-link>
            </div>
          </li>
          <li>
            <div class="nav-dropdown">
              <div class="nav-dropdown__display">
                <button class="btn btn-sm flex items-center" aria-label="flag" @click="openLangSelectModal">
                  <!-- <CountryFlag :country="selectedLangFlag" size='normal' class="rounded-sm" style="margin: 0 -0.7em" :style="!isWhite && 'border: 1px solid #dddfe2;'" /> -->
                  <img width="20" :src="(isWhite || isEventWhite) ? require('@/assets/images/menu/icon-language-white.svg') : require('@/assets/images/menu/icon-language.svg')" alt="">
                </button>
              </div>
            </div>
          </li>
          <li>
            <div class="nav-dropdown">
              <div class="nav-dropdown__display">
                <button class="btn btn-sm flex items-center" @click="openCurrencySelectModal" :style="isEventWhite ? 'color: white' : 'color: black'">
                  <span class="mr-8 nav-text">{{ this['user/selectedCurrency'] }}</span>
                </button>
              </div>
            </div>
          </li>
          <li>
            <div class="nav-dropdown">
              <router-link class="nav-dropdown__display no-underline" :to="{name: 'Promotion'}">
                <button class="btn btn-sm flex items-center" :style="isEventWhite ? 'color: white' : 'color: black'">
                  <span class="mr-8 nav-text">{{ $t('hostAHotel') }}</span>
                  <!-- <i class="owl-caret-bottom"></i> -->
                </button>
              </router-link>
              <!-- <div class="nav-dropdown__list">
                <li>
                  <router-link class="no-underline" :to="{name: 'Promotion'}">
                    <span>{{ $t('joinMember') }}</span>
                  </router-link>
                </li>
                <li>
                  <a class="no-underline" href="https://www.owlting.com/booking/admin?p=dashboard" target="_blank">{{ $t('loginBackstage') }}</a>
                </li>
              </div> -->
            </div>
          </li>
          <template v-if="!this['user/isLoading']">
            <li class="flex user-status" v-if="!this['user/isLogin']">
              <button class="login-btn btn btn-sm btn-text btn-blue font-bold self-center text-sm" @click="this['user/goLogin']" :style="isEventWhite ? 'color: white' : 'color: black'">{{ $t('login') }}</button>
            </li>
            <li class="flex user-status" v-if="this['user/isLogin']">
              <div class="nav-dropdown user__info flex items-center">
                <div class="nav-dropdown__display cursor-pointer" @click="onClickUser()">
                  <div class="user__info__avatar mr-8 relative">
                    <div class="img rounded-full" :class="isPremium ? 'relative border-2 border-premium' : 'border border-grey-light'" :style="`background-image: url('${this['user/profile'].avatarUrl}');`" style="padding-top: 32px; padding-left: 32px;"></div>
                    <premiumImage class="absolute" v-if="isPremium" type="icon" style="bottom: -4px; right: -4px; transform: scale(0.8);"></premiumImage>
                  </div>
                  <span class="text-lg" :class="isEventWhite ? 'text-white' : 'text-grey-gard'">
                    <i class="owl-more-v"></i>
                  </span>
                </div>
                <div class="nav-dropdown__list" style="min-width: 240px;">
                  <template>
                    <div class="flex p-16 items-center">
                      <div class="user__info__avatar mr-16 relative">
                        <div class="img border border-grey-light rounded-full" :style="`background-image: url('${this['user/profile'].avatarUrl}');`" style="padding-top: 38px; padding-left: 38px;"></div>
                      </div>
                      <div class="text-overflow-ellipsis">
                        <span class="block font-semibold text-overflow-ellipsis">{{ this['user/profile'].nickname }}</span>
                        <span class="flex items-center text-sm mt-4">
                          <template v-if="isPremium">
                            <premiumImage type="icon" class="mr-4" style="transform: scale(0.8);" />
                            <span class="font-bold text-premium">{{ $t('user.premium') }}</span>
                          </template>
                          <template v-else>
                            <span class="font-semibold text-grey">{{ $t('user.normal') }}</span>
                          </template>
                        </span>
                      </div>
                    </div>
                    <li v-if="isTouchDevice" @click="onOpenLangModal"><span>{{ this['user/selectedLangName'] }}</span></li>
                    <li v-if="isTouchDevice" @click="onOpenCurrencyModal"><span>{{ this['user/selectedCurrencyName'] }}</span></li>
                    <li>
                      <router-link :to="{name: 'UserSaved'}">
                        <img width="28" height="28" class="mr-16" :src="getIconPath('UserSaved')" alt="saved icon" />
                        <span>{{ $t('user.save') }}</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link :to="{name: 'UserHistory'}">
                        <img width="28" height="28" class="mr-16" :src="getIconPath('UserHistory')" alt="history icon" />
                        <span>{{ $t('user.orders') }}</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link :to="{name: 'UserPoints'}">
                        <img width="28" height="28" class="mr-16" :src="getIconPath('UserPoints')" alt="points icon" />
                        <span>{{ $t('user.discount') }}</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link :to="{name: 'UserInfo'}">
                        <img width="28" height="28" class="mr-16" :src="getIconPath('UserInfo')" alt="info icon" />
                        <span>{{ $t('user.info') }}</span>
                      </router-link>
                    </li>
                    <li v-if="isPremium" class="premium">
                      <router-link :to="{name: 'UserPremium'}">
                        <img width="28" height="28" class="mr-16" :src="getIconPath('UserPremium')" alt="premium icon" />
                        <span>{{ $t('user.premium') }}</span>
                      </router-link>
                    </li>
                    <div v-if="!isPremium" class="m-16">
                      <a class="no-underline border-1 border-grey-lighter shadow-md rounded" :href="premiumUrl">
                        <div class="flex flex-col items-center p-16 w-full">
                          <premiumImage class="mr-4 mb-4" type="logo" style="transform: scale(0.8)"></premiumImage>
                          <div class="font-medium leading-sm text-xs text-center">
                            <div class="text-grey-darkest">{{ $t('premium.title') }}</div>
                            <div>
                              <span class="text-grey-darkest">{{ $t("premium.text[0]") }}</span>
                              <span class="text-premium-dark">{{ $t("premium.text[1]") }}</span>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                    <hr class="border-b border-grey-lighter m-0 p-0">
                    <li @click="logoutHandler"><span class="block py-8 text-blue-light">{{ $t('logout') }}</span></li>
                  </template>
                </div>
              </div>
            </li>
          </template>
          <template v-else>
            <li class="flex items-center user-status loadingUser">
              <i class="owl-arrow-reload"></i><span class="ml-8">{{ $t('loading') }}</span>
            </li>
          </template>
        </ul>
      </div>
      <div v-if="!hideLogout" class="travelNav--mobile">
        <!-- <button class="travelNav--mobile__button text-3xl" @click="toggleSidebar"><i class="owl-search"></i></button> -->
        <template v-if="!this['user/isLogin']">
          <!-- <span v-if="this['user/isLoading']" class="text-sm text-grey">{{ $t('loading') }}</span> -->
        </template>
        <template v-else>
          <button class="travelNav--mobile__button" @click="toggleMobileMenu" aria-label="avatar">
            <div class="user__info__avatar mr-8 relative">
              <div class="img rounded-full" :class="isPremium ? 'relative border-2 border-premium' : 'border border-grey-light'" :style="`background-image: url('${this['user/profile'].avatarUrl}');`" style="padding-top: 32px; padding-left: 32px;"></div>
              <premiumImage v-if="isPremium" class="absolute" type="icon" style="bottom: -4px; right: -4px; transform: scale(0.8);"></premiumImage>
            </div>
          </button>
        </template>
        <button class="travelNav--mobile__button text-3xl" :class="isWhite ? 'isWhite' : null" aria-label="menu" @click="toggleMobileMenu">
          <i :class="isMenuOpen ? 'owl-status-error' : 'owl-menu'"></i>
        </button>
      </div>
    </div>
    <searchBar v-if="isSearchBar" class="whitespace-no-wrap"></searchBar>
    <hotelNavigator v-show="isHotelNavigator && scrollTop > 460 && orderStep === 1"></hotelNavigator>
    <modal class="mobileMenu langModal" name="langModal" :adaptive="true" width="80%" height="80%">
      <li v-for="lang in this['user/langsList']" :key="lang.code" :class="isSelectedLang(lang.code)" @click="switchLang(lang.code)">{{lang.name}}</li>
    </modal>
    <modal class="mobileMenu currencyModal" name="currencyModal" :adaptive="true" width="80%" height="80%">
      <div @click="$modal.hide('currencyModal')">
        <li v-for="(currency, index) in this['user/currenciesList']" :class="isSelectedCurrency(currency.code)" @click="switchCurrency(currency.code)" :key="index">
          <span>{{ currency.name }}</span>
          <span class="ml-4">{{ currency.icon }}</span>
        </li>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import searchBar from '@/layouts/searchBar'
// import hotelNavigator from '@/layouts/hotelNavigator'
import mobileUserMenu from '@/components/mobileUserMenu.vue'
import mobileHotelMenu from '@/components/mobileHotelMenu.vue'
import iconsMixin from '@/mixins/icons'
import localeMixin from '@/mixins/locale'
import CountryFlag from 'vue-country-flag'
import fullPageModal from '@/components/modals/fullPageModal'
import currencySelect from '@/components/currencySelect'
import langSelect from '@/components/langSelect'
import { require } from 'vue-analytics'

export default {
  name: 'travelNav',
  mixins: [iconsMixin, localeMixin],
  components: {
    searchBar,
    'hotelNavigator': () => import('@/layouts/hotelNavigator'),
    CountryFlag
  },
  props: {
    isWhite: Boolean
  },
  data () {
    return {
      isSearchInputActivated: false
    }
  },
  computed: {
    ...mapGetters({
      scrollTop: 'scrollTop',
      isTouchDevice: 'isTouchDevice',
      'user/langsList': 'user/langsList',
      'user/currenciesList': 'user/currenciesList',
      'user/selectedCurrency': 'user/selectedCurrency',
      'user/selectedCurrencyName': 'user/selectedCurrencyName',
      'user/selectedLang': 'user/selectedLang',
      'user/selectedLangName': 'user/selectedLangName',
      selectedLangFlag: 'user/selectLangFlagCode',
      'user/profile': 'user/profile',
      'user/isLoading': 'user/isLoading',
      'user/isLogin': 'user/isLogin',
      isDesktop: 'isDesktop',
      isMenuOpen: 'user/isMobileMenuOpen',
      isSuper: 'isSuper',
      isPremium: 'user/isPremium',
      premiumUrl: 'user/premiumUrl',
      orderStep: 'order/step',
      headerTextColor: 'events/headerTextColor',
      headerBgColor: 'events/headerBgColor'
    }),
    hideNavBar: function () {
      return this.$route.meta.hideNavBar
    },
    isSearchBar: function () {
      if (this.$route.meta.hasSearchBar === true) {
        return true
      }
      return false
    },
    isHotelNavigator: function () {
      if (this.$route.meta.hasHotelNavigator === true) {
        return true
      }
      return false
    },
    isHotelDetail: function () {
      return this.$route.name === 'HotelDetail'
    },
    hideLogout: function () {
      return this.$route.name === 'OrderBid'
    },
    isEventPage: function () {
      return this.$route.name === 'Event'
    },
    isEventWhite: function () {
      return this.isEventPage && this.headerTextColor === '#ffffff'
    },
    isEventBgColor: function () {
      return this.isEventPage && this.headerBgColor !== '#ffffff'
    }
  },
  methods: {
    ...mapActions([
      'bodyLock',
      'user/goLogin',
      'user/goLogout',
      'user/setLoginLoading',
      'user/switchLang',
      'user/switchCurrency',
      'user/toggleMobileMenu'
    ]),
    openSearchInput: function ($event) {
      this.isSearchInputActivated = !this.isSearchInputActivated
    },
    toggleSidebar: function (target) {
      this.$sidebar.toggle()
      this.$sidebar.set()
      this.$sidebar.focus(target)
    },
    toggleMobileMenu: function (target) {
      this.$mobileMenu.toggle()
      this.$mobileMenu.set({
        offsetHeight: this.$el.offsetHeight
      })
      this.$mobileMenu.focus(target)
    },
    openMobileUser: function () {
      this.$modal.show(mobileUserMenu, {
        // 輸入內容
        // context: ordersCart
      },
      {
        adaptive: true,
        name: 'mobileUserMenu',
        // clickToClose: false,
        height: 'auto',
        width: '90%',
        scrollable: true
      })
    },
    openMobileHotelMenu: function () {
      this.$modal.show(mobileHotelMenu, {
        // 輸入內容
        // context: ordersCart
      },
      {
        adaptive: true,
        name: 'mobileHotelMenu',
        // clickToClose: false,
        height: 'auto',
        width: '90%',
        scrollable: true
      })
    },
    openCurrencySelectModal: function () {
      this.$modal.show(fullPageModal, {
        context: currencySelect,
        title: this.$t('currencyTitle')
      },
      {
        adaptive: true,
        name: 'currencySelect',
        width: '70%',
        height: 'auto',
        minWidth: 375,
        maxWidth: 800,
        scrollable: true
      })
    },
    openLangSelectModal: function () {
      this.$modal.show(fullPageModal, {
        context: langSelect,
        title: this.$t('langTitle')
      },
      {
        adaptive: true,
        name: 'langSelect',
        width: '70%',
        height: 'auto',
        minWidth: 375,
        maxWidth: 800,
        scrollable: true
      })
    },
    onClickUser: function () {
      const isTouchDevice = this.isTouchDevice
      if (isTouchDevice) {
        return false
      } else {
        this.$router.push({
          name: 'User'
        })
      }
    },
    onOpenLangModal: function () {
      this.$modal.show('langModal')
    },
    onOpenCurrencyModal: function () {
      this.$modal.show('currencyModal')
    },
    isSelectedCurrency: function (currency) {
      return currency === this['user/selectedCurrency'] ? 'activate' : null
    },
    isSelectedLang: function (lang) {
      return lang === this['user/selectedLang'] ? 'activate' : null
    },
    switchLang: function (lang) {
      this['user/switchLang'](lang)
    },
    switchCurrency: function (currency) {
      this['user/switchCurrency'](currency)
    },
    logoutHandler: function () {
      this['user/goLogout']()
    },
    updateLoginLoadingStatus: function () {
      this['user/setLoginLoading'](false)
    }
  },
  created () {
    window.addEventListener('beforeunload', this.updateLoginLoadingStatus)
  },
  mounted () {
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.updateLoginLoadingStatus)
  },
  watch: {
    '$route.path' () {
      this['user/toggleMobileMenu'](false)
      this.bodyLock(false)
    }
  }
}
</script>

<style lang="sass" scoped>
.travelNav
  @apply sticky pin-t bg-white select-none
  z-index: 11
  transition: all ease-out 0.3s
  transform: translateY(0px)
  &.isHotelDetail
    @apply relative
    @screen lg
      @apply sticky
  &.isTransparent
    @apply bg-transparent
  &.isFixed
    @apply absolute w-full
  &.isWhite
    background: linear-gradient(to bottom, rgba(0,0,0,0.8) -80%, rgba(0,0,0,0) 100%)
    .travelNav--right > ul > li
      button, a button, .nav-dropdown__display button, .nav-dropdown__display .owl-more-v
        @apply text-white #{!important}
  &__wrap
    @apply flex justify-between items-center px-16
    .logo-wrap
      @apply flex items-center
      height: 52px
      @screen lg
        height: 60px
      .logo
        @apply inline-block pr-8
        width: 164px
        @screen lg
          width: 200px
    .travelNav--right
      @apply hidden
      @screen lg
        @apply block
      & > ul
        @apply list-reset flex items-stretch h-full
        & > li
          @apply px-8 flex-auto flex content-center
          a
            @apply h-full flex content-center items-center
        & > li:not(.user-status)
          @apply hidden
          @screen lg
            @apply flex items-center
    .travelNav--mobile
      @apply flex flex-row items-center
      @screen lg
        @apply hidden
      &__button
        @apply text-grey ease outline-none
        &:hover
          @apply text-blue
        &.isWhite
          @apply text-white
  .user
      &__info
        a
          @apply no-underline
        &__avatar
          // @apply border border-grey-lighter
          .img
            @apply bg-center bg-cover

.nav-dropdown
  @apply relative flex items-stretch h-full
  &__display
    @apply flex content-center items-center
    button
      @apply font-bold text-sm
  &__list
    @apply absolute bg-white shadow-lg z-10 rounded-b-sm hidden overflow-hidden
    min-width: 150px
    width: 100%
    top: 100%
    right: -16px
    transition: all 0.3s ease
    li .router-link-active span
      @apply text-blue-light
    a
      @apply text-grey-darker
    li
      @apply font-medium leading-normal px-16 py-8 cursor-pointer text-sm w-full
      i
        @apply text-grey-light
        &:before
          @apply mx-0
      &:hover
        @apply bg-grey-lightest
        a
          @apply text-grey-darkest
      &.activate
        @apply font-bold text-blue-light
  &:hover
    & > .nav-dropdown__list
      @apply block

.data-result-modal
    @apply bg-transparent
.loadingUser
  @apply text-grey-dark text-sm
  i
    animation: spining 2.4s cubic-bezier(0.5, 0, 0.5, 1) infinite

.text-premium
  color: $premium
@keyframes spining
  0%
    transform: rotate(0deg)
    @apply text-grey opacity-50
  50%, 60%
    transform: rotate(360deg)
    @apply text-blue opacity-100
  100%
    transform: rotate(720deg)
    @apply text-grey opacity-50
</style>
<style lang="sass">
.travelNav__wrap
  .nav-dropdown__list
    a.router-link-exact-active
      @apply font-bold text-blue-light
      .premium
        color: $premium
        i
          background-color: $premium

  .premium
    @apply flex items-center
    i
      color: white
      @apply bg-grey-dark flex items-center justify-center mr-4
      width: 16px
      height: 16px
</style>
